@let s = status();
<div class="schedule-display" [class]="'schedule-display--' + s.state">
  <fa-icon class="icon" [icon]="faClock"></fa-icon>
  <span class="text">
    @switch (s.state) {
      @case ('in-progress') {
        {{ 'In progress' | translate }}
        <span class="muted">· {{ 'Ends [time]' | translate: { time: (s.end | localizedDate: 'shortTime') } }}</span>
      }
      @case ('upcoming') {
        {{ 'Starts [time]' | translate: { time: (s.start | localizedDate: 'short') } }}
      }
      @case ('ended') {
        {{ 'Ended' | translate }}
      }
    }
    @if (repeatLabel(); as repeat) {
      <span class="muted">· {{ repeat }}</span>
    }
  </span>
</div>
